import styled from '@emotion/styled';

const InvisibleInput = styled('input')({
  display: 'none',
});

export default InvisibleInput;
